import { render, staticRenderFns } from "./ContactoDatos.vue?vue&type=template&id=087c85f8"
import script from "./ContactoDatos.vue?vue&type=script&lang=js"
export * from "./ContactoDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports